import { createFileRoute } from '@tanstack/react-router'
import { OverviewDashboard } from '@/features/catalog/components/overview/overview-dashboard'

export const Route = createFileRoute('/_authenticated/command-center/')({
  component: OverviewDashboard,
})
